<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">Advance บัตร (โควต้า)</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        สร้างชุดรหัส activate ตามโควต้า — ลาน:
        <span class="font-bold text-amber-600">{{ siteState.selectedSite()?.name || '-' }}</span>
      </p>
      <p *ngIf="clientScope.isRestricted()" class="text-xs text-amber-700 dark:text-amber-400 mt-2 flex items-center gap-1">
        <span class="material-icons text-sm">store</span>
        แสดงเฉพาะ Advance ร้าน: <span class="font-bold">{{ clientScope.scopeSummaryLabel() }}</span>
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <div
        class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px]">
        <span class="material-icons text-slate-400 text-xl">calendar_today</span>
        <div class="relative w-full sm:w-[130px] h-full flex items-center">
          <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ dateFrom() | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 text-lg">expand_more</span>
          </div>
          <input #startDatePicker type="date" [ngModel]="dateFrom()" (ngModelChange)="dateFrom.set($event); onDateChange()"
            [max]="dateTo()" (click)="startDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>
        <span class="text-slate-300 dark:text-slate-600">-</span>
        <div class="relative w-full sm:w-[130px] h-full flex items-center">
          <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ dateTo() | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 text-lg">expand_more</span>
          </div>
          <input #endDatePicker type="date" [ngModel]="dateTo()" (ngModelChange)="dateTo.set($event); onDateChange()"
            [min]="dateFrom()" (click)="endDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>
      </div>
      <button type="button" (click)="applyPresetDays(30)"
        class="px-3 py-2.5 text-xs font-bold rounded-xl border border-slate-200 dark:border-slate-700 bg-white/95 dark:bg-slate-900/95 hover:bg-amber-50 hover:border-amber-300 transition-all h-[46px]">
        30 วัน
      </button>
      <button type="button" (click)="applyThisMonth()"
        class="px-3 py-2.5 text-xs font-bold rounded-xl border border-slate-200 dark:border-slate-700 bg-white/95 dark:bg-slate-900/95 hover:bg-amber-50 hover:border-amber-300 transition-all h-[46px]">
        เดือนนี้
      </button>
      <button type="button" (click)="onRefresh()"
        class="p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all flex items-center justify-center h-[46px]">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg flex items-center justify-center gap-2 h-[46px]">
        <span class="material-icons">add_circle</span> สร้าง Advance
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/50 dark:border-slate-800/50 flex flex-col sm:flex-row sm:items-end justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">confirmation_number</span>
        รายการ Advance (Quota)
      </h3>
      <div class="w-full sm:w-56">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สถานะ</label>
        <select [ngModel]="filterStatus()" (ngModelChange)="filterStatus.set($event); onFilterChange()"
          class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
          <option *ngFor="let o of statusOptions" [ngValue]="o.value">{{ o.label }}</option>
        </select>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading() || isExporting()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50 dark:border-slate-800/50">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">เลขที่</th>
            <th class="p-4">วันที่สร้าง</th>
            <th class="p-4">ร้าน</th>
            <th class="p-4">ประเภทรถ</th>
            <th class="p-4">โควต้า / บัตร</th>
            <th class="p-4 text-center">จำนวน</th>
            <th class="p-4 text-center">สถานะ</th>
            <th class="p-4">ช่วงบัตร</th>
            <th class="p-4 text-center w-[150px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-all">
            <td class="p-4 font-semibold text-slate-700 dark:text-slate-200">{{ item.name }}</td>
            <td class="p-4 text-slate-400 text-xs whitespace-nowrap">{{ item.createDate | date:'dd/MM/yyyy HH:mm' }}</td>
            <td class="p-4 text-sm">{{ item.clientName }}</td>
            <td class="p-4 text-sm">{{ item.vehicleTypeName || '-' }}</td>
            <td class="p-4">
              <div class="font-medium text-slate-700 dark:text-slate-200">{{ item.quotaName || '-' }}</div>
              <div class="text-xs text-slate-400">{{ item.cardTypeName }}</div>
            </td>
            <td class="p-4 text-center font-bold">{{ item.qty }}</td>
            <td class="p-4 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold" [ngClass]="statusBadgeClass(item.status)">
                {{ statusLabel(item.status) }}
              </span>
              <div *ngIf="item.status === 3" class="text-[11px] text-slate-400 mt-1">{{ item.activateCodeCount }} รหัส</div>
            </td>
            <td class="p-4 text-xs whitespace-nowrap text-slate-500">
              {{ item.startDate | date:'dd/MM/yyyy' }} - {{ item.endDate | date:'dd/MM/yyyy' }}
            </td>
            <td class="p-4">
              <div class="flex justify-center gap-1 flex-wrap">
                <button type="button" (click)="openDetail(item)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 dark:border-slate-700 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all"
                  title="ดูรายละเอียด">
                  <span class="material-icons text-base">visibility</span>
                </button>
                <button *ngIf="canUpdate && item.status === 1" type="button" (click)="openEdit(item)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 dark:border-slate-700 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all"
                  title="แก้ไข">
                  <span class="material-icons text-base">edit</span>
                </button>
                <button *ngIf="canUpdate && item.status === 2" type="button" (click)="execute(item)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 dark:border-slate-700 hover:border-blue-400 text-slate-400 hover:text-blue-500 transition-all"
                  title="Gen Code">
                  <span class="material-icons text-base">qr_code</span>
                </button>
                <button *ngIf="item.status === 3" type="button" (click)="exportExcel(item)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 dark:border-slate-700 hover:border-emerald-400 text-slate-400 hover:text-emerald-500 transition-all"
                  title="Export Excel">
                  <span class="material-icons text-base">download</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="items().length === 0 && !isLoading()">
            <td colspan="9" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">search_off</span>
              <p class="font-bold">{{ selectedSiteId ? 'ไม่พบข้อมูลในช่วงวันที่และเงื่อนไขที่เลือก' : 'กรุณาเลือกลานจากแถบด้านข้าง' }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/50 dark:border-slate-800/50 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let p of pagesArray" type="button" (click)="setPage(p)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold"
          [ngClass]="p === currentPage() ? 'bg-amber-400 text-white' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-amber-900/20'">
          {{ p }}
        </button>
        <button type="button" (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading() || isExporting()"></app-pss-loading>

<app-modal-quota-card-advance *ngIf="isModalOpen()" [advanceId]="selectedAdvanceId()" [siteId]="selectedSiteId"
  [initialClientId]="initialClientIdForModal" (close)="closeModal()" (saveSuccess)="loadScopeAndTable()"></app-modal-quota-card-advance>

<app-modal-quota-card-advance-detail *ngIf="isDetailModalOpen()" [advanceId]="detailAdvanceId()"
  (close)="closeDetailModal()"></app-modal-quota-card-advance-detail>

<app-pss-confirm-modal *ngIf="isExecuteConfirmOpen()" title="ยืนยันการ Gen Code?" message="สร้างรหัส activate"
  [highlight]="executeQtyHighlight" messageSuffix="รายการหรือไม่?" confirmLabel="Gen Code"
  variant="warning" icon="confirmation_number" [showIrreversibleNote]="false"
  (confirm)="confirmExecuteAdvance()" (cancel)="closeExecuteConfirm()">
</app-pss-confirm-modal>
